import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

export const STATISTICS_PATH = '/statistics/';

const STATISTICS_RAW_PATH = `${STATISTICS_PATH}raw/`;

export const statisticsRoutesConfig = createRouteConfig(
  {
    statistics: {
      path: STATISTICS_PATH,
      generatePath: () => STATISTICS_PATH,
    },
    statisticsRaw: {
      path: STATISTICS_RAW_PATH,
      generatePath: () => STATISTICS_RAW_PATH,
    },
  },
  STATISTICS_PATH,
);
